(function () {
    if (window.__rotatingReviewsHasFired) {
      return;
    }

    window.Branch = window.Branch || {};
    window.Branch.rotatingReviews = window.Branch.rotatingReviews || {};
    window.Branch.rotatingReviews.sliders = window.Branch.rotatingReviews.sliders || {};
    window.__rotatingReviewsHasFired = true;

    function initRotatingReviewSlider(rotatingReviewsSection, parent){
        let parentId = parent.getAttribute('id');
        let enable_autoscroll = rotatingReviewsSection.getAttribute('data-enable-autoscroll') == 'true';
        let autoscroll_interval = 1000 * parseInt(rotatingReviewsSection.getAttribute('data-autoscroll-interval'));

        let autoplay = !enable_autoscroll ? false : {delay: autoscroll_interval, disableOnInteraction: true}
        
        window.Branch.rotatingReviews.sliders[`${parentId}`] = new Swiper(`#${parentId} .rotating-reviews__slider`, {
            spaceBetween: 0,
            centeredSlides: true,
            slidesPerView: 'auto',
            autoplay: autoplay,
            touchRatio: 0.2,
            slideToClickedSlide: true,
            loop: true,
            navigation: {
                    nextEl: `#${parentId} .rotating-reviews__nav-right`,
                    prevEl: `#${parentId} .rotating-reviews__nav-left`,
                }
        });
    }

    window.Branch.rotatingReviews.rotatingReviewsInitOnLoad = function(){
        let rotatingReviewsSections = document.querySelectorAll('.rotating-reviews:not([data-initialized="true"])');
        rotatingReviewsSections.forEach((rotatingReviewSection) => {
            let parent = rotatingReviewSection.closest('.shopify-section');
            rotatingReviewSection.setAttribute('data-initialized', true);
            initRotatingReviewSlider(rotatingReviewSection, parent);
        })  
    }

    if (document.readyState === "complete") {
        window.Branch.rotatingReviews.rotatingReviewsInitOnLoad(); 
    } else {
        window.addEventListener("load", window.Branch.rotatingReviews.rotatingReviewsInitOnLoad);
    }
  })();
